import { LeaseDetailsModel, ResidentLeaseBasicInfo } from 'api/models';

type SignaturesByUserId = {
  [key: string]: {
    // Both are optional here because they are read off an optional `leaseInfo`
    // below. The one consumer compares each against a literal, so an absent value
    // behaves as it always has.
    residentType?: ResidentLeaseBasicInfo['residentType'];
    signatureStatus?: ResidentLeaseBasicInfo['signatureStatus'];
  };
};

export const getLeaseSignaturesStatus = (lease?: LeaseDetailsModel) => {
  let primaryUserId = '';
  const signaturesByUserId: SignaturesByUserId = {};

  if (!lease) return { signaturesByUserId };

  // Every level here is optional in the model, and this already mixes `?.` with
  // direct reads on the same chain; the optional form is applied consistently.
  lease.residents?.forEach((resident) => {
    if (
      resident?.leaseInfo?.residentType === 'Primary' &&
      resident.basicInfo?.userInfo?.userId
    ) {
      primaryUserId = resident.basicInfo?.userInfo?.userId;
    }
    if (resident.basicInfo?.userInfo?.userId) {
      signaturesByUserId[resident.basicInfo?.userInfo.userId] = {
        residentType: resident?.leaseInfo?.residentType,
        signatureStatus: resident?.leaseInfo?.signatureStatus,
      };
    }
  });

  return {
    signaturesByUserId,
    isPrimaryResidentSignaturePending:
      !!primaryUserId &&
      !!signaturesByUserId[primaryUserId] &&
      signaturesByUserId[primaryUserId]!.signatureStatus === 'Pending',
  };
};
